module.exports = __webpack_public_path__ + "90f828d4292eed1d5db511c0358b4c6e.svg";